import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import TableView from '../Table/Table';
import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

import { addTerminalProcessorGroup, fetchProcessorTerminalGroups, deleteProcessorTerminalGroup, fetchProcessingGroupHistory } from '../../../redux/actions/ProcessingGroupActions';
import { setProcessorTerminalID } from '../../../redux/actions/ProcessorTerminalActions';
import { fetchProcessorTerminalsForAssignment } from '../../../redux/actions/DropdownActions';
import SweetAlert from 'react-bootstrap-sweetalert';

const ProcessorPrefix = (props) => {

    const [delModelOpen, setDelModelOpen] = useState(false);
    const [addModelOpen, setAddModelOpen] = useState(false)

    const [data, setData] = useState(null)

    const [processorTermID, setProcessorTermID] = useState('')
    const [connectionID, setConnectionID] = useState('')
    const [processingGroupID, setProcessingGroupID] = useState('')
    const [priority, setPriority] = useState('')
    const [processorID, setProcessorID] = useState('')

    const [, setProcessorTermIDError] = useState(false)
    const [, setProcessingGroupIDError] = useState(false)
    const [, setPriorityError] = useState(false)
    const [processorIDError] = useState(false)

    const [connectionsDropdown, setConnectionsDropdown] = useState([])
    const [processorTerminalsDropdown, setProcessorTerminalsDropdown] = useState([])

    const [, setAvailableTIDs] = useState([])




    useEffect(() => {
        let processingGroupID = props.processingGroupID;
        if (processingGroupID) {
            setProcessingGroupID(props.processingGroupID)
            props.fetchProcessorTerminalGroups(processingGroupID)
            setProcessingGroupID(processingGroupID)
            props.fetchProcessorTerminalsForAssignment(props.merchantID)
            console.log('TIDs available ', props.DROPDOWNREDUCER.processorTerminals)
            setAvailableTIDs(props.DROPDOWNREDUCER.processorTerminals)

        }
    }, [])


    const handleDeleteConfirmation = () => {

        let body = {}
        body.processorTermID = data?.data?.processorTermID
        body.groupID = processingGroupID
        body.merchantID = props.merchantID


        if (body.processorTermID, body.groupID) {
            props.deleteProcessorTerminalGroup(body)
            setDelModelOpen(false)

        }



    }
    const handleDeleteButton = (value) => {
        setDelModelOpen(true)
    }

    const onCellClicked = (value) => {
        setData(value)
    }

    const handleAddButton = (value) => {
        setAddModelOpen(true)
    }

    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'processorID':
                setProcessorID(targetValue)
                let connections = props.DROPDOWNREDUCER.processorTerminals.filter(processor => {
                    return String(processor.processorID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                })
                setConnectionsDropdown(connections[0]?.processorConnections)
                break;
            case 'connectionID':
                setConnectionID(targetValue)

                let processorTerminal = connectionsDropdown.filter(connection => {
                    return String(connection.connectionID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                })
                console.log('processorTerminal : ', processorTerminal[0]?.processorTermID)
                setProcessorTerminalsDropdown(processorTerminal[0]?.processorTermID)
                break;

            case 'processorTermID':
                setProcessorTermID(targetValue)
                setProcessorTermIDError(false)
                break;
            case 'processingGroupID':
                setProcessingGroupID(targetValue)
                setProcessingGroupIDError(false)
                break;
            case 'priority':
                setPriority(targetValue)
                setPriorityError(false)
                break;
            default:
                break;

        }

    }


    const handleAdd = () => {

        let body = {}

        body.merchantID = props.merchantID

        if (processorID) {
            body.processorTermID = processorTermID
        }
        if (processingGroupID) {
            body.processingGroupID = processingGroupID
        }
        if (priority) {
            body.priority = priority
        }
        if (connectionID) {
            body.connectionID = connectionID
        }

        if (body.processorTermID, body.processingGroupID, body.connectionID) {
            props.addTerminalProcessorGroup(body)
            setAddModelOpen(false)
            handleReset()
        }

    }

    const handleReset = () => {

        setProcessorID('')
        setConnectionID('')
        setProcessorTermID('')


    }

    const DELETE_CONFIRMATION = (
        <p className="lead text-dark">
            <SweetAlert danger showCancel
                confirmBtnText="Yes!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                onConfirm={handleDeleteConfirmation}
                onCancel={() => setDelModelOpen(!delModelOpen)}
            >

                <b> Are you sure you want to remove - {data?.data?.processorTermID}</b>

            </SweetAlert>
        </p>
    )


    const ADD_PROCESSOR_TERMID_FORM = (
        
        <p className="lead text-dark ">

            <SweetAlert
                showCancel
                confirmBtnText="Add"
                cancelBtnBsStyle="default"
                onConfirm={handleAdd}
                onCancel={() => setAddModelOpen(!addModelOpen)}
            >

                <Panel >
                    <PanelHeader>ADD PROCESSOR TERMINAL FORM</PanelHeader>
                    <PanelBody>

                        <form className="fs-13px">

                            <div className="mb-3">

                                <div className="row gx-6">

                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-3 " + (processorIDError ? 'text-danger' : '')} ><b>Processor</b></label>
                                        <select className="form-select"
                                            onChange={handleChange}
                                            name='processorID'
                                            value={processorID ? processorID : ' '}
                                        >
                                            <option value=''>Select Processor</option>
                                            {props.DROPDOWNREDUCER.processorTerminals.length > 0 ? props.DROPDOWNREDUCER.processorTerminals.map((option) => (
                                                <option key={option.processorID} value={option.processorID}>
                                                    {option.processorName}
                                                </option>
                                            ))
                                                : <></>
                                            }

                                        </select>
                                    </div>
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <select className="form-select"
                                            onChange={handleChange}
                                            name='connectionID'
                                            value={connectionID ? connectionID : ''}
                                        >
                                            <option value=''>Select Connection</option>
                                            {connectionsDropdown.map((option) => (
                                                <option key={option.connectionID} value={option.connectionID}>
                                                    {option.connectionName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <select className="form-select"
                                            value={processorTermID ? processorTermID : ''}
                                            onChange={handleChange}
                                            name='processorTermID'
                                        >
                                            <option value=''>Select Processor Terminal</option>
                                            {processorTerminalsDropdown?.map((option) => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}

                                        </select>
                                    </div>

                                </div>
                            </div>

                        </form>

                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p>

    )


    const historyHeadings = {

        prefixHeadings: [
            { field: 'processorTermID', tooltipField: 'processorTermID', headerName: 'P TID', minWidth: 100, maxWidth: 100 },
            { field: 'priority', tooltipField: 'priority', headerName: 'Priority', minWidth: 100, maxWidth: 90 },
            { field: 'connectionName', tooltipField: 'connectionName', headerName: 'Connection Name', minWidth: 180 },

            {
                field: 'Action', tooltipField: 'action', headerName: '', minWidth: 80, cellRenderer: function (params) {
                    return <button className="btn btn-danger btn-icon btn-circle btn-sm me-1" onClick={handleDeleteButton}>X</button>
                }
            },
        ]
    }


    return (

        <Panel>

            <PanelHeader>

                <div className="row mb-0">
                    <div className="col-xl-7">
                        <b>PROCESSING GROUP</b>
                    </div>
                    <div className="col-xl-5">
                        <button className='btn btn-secondary btn-xs' onClick={handleAddButton}>Add Processor Terminal</button>
                    </div>
                </div>

            </PanelHeader>

            {/* <PanelBody> */}
            < TableView height={300} headings={historyHeadings.prefixHeadings} data={props.PROCESSORGROUPSREDUCER.processorTerminalGroups[processingGroupID]} handleClick={onCellClicked} />
            {/* </PanelBody> */}
            {delModelOpen ?
                DELETE_CONFIRMATION : null
            }
            {addModelOpen ?
                ADD_PROCESSOR_TERMID_FORM : null
            }
        </Panel>

    )

}
function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    addTerminalProcessorGroup,
    deleteProcessorTerminalGroup,
    fetchProcessorTerminalGroups,
    setProcessorTerminalID,
    fetchProcessingGroupHistory,
    fetchProcessorTerminalsForAssignment
}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessorPrefix);

